exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.ellipsis input{text-overflow:ellipsis !important;white-space:nowrap !important;overflow:hidden !important\n}\n", "", {"version":3,"sources":["/app/frontend/src/screens/analise/components/AppDadosProcesso.vue"],"names":[],"mappings":";AAgEA,gBAEI,kCACA,8BACA,0BAA2B;CAC5B","file":"AppDadosProcesso.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.ellipsis {\n  input {\n    text-overflow: ellipsis !important;\n    white-space: nowrap !important;\n    overflow: hidden !important;\n  }\n}\n\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ff9ce1f4","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/screens/analise/components/AppDadosProcesso.vue
// module id = EnXZ
// module chunks = 11